import Link from 'next/link';
import React from 'react';
import { TYPES } from '../../../../ui-components/typography/PlayText/PlayText';
import { StyledCategories, CategoryHeading, CategoryList, CategoryLink, Category } from './Categories.styles';

export const Categories = ({ categories }) => (
    <StyledCategories>
        <CategoryHeading>Genrer</CategoryHeading>
        <CategoryList>
            {categories &&
                categories.map((category, i) => (
                    <Category key={`category-${i}`} data-rt="details-page-genre-link">
                        <Link href={`/genre/${category.id}`} passHref>
                            <CategoryLink to={`/genre/${category.id}`} type={TYPES.MINI}>
                                {category.heading}
                            </CategoryLink>
                        </Link>
                    </Category>
                ))}
        </CategoryList>
    </StyledCategories>
);
export default Categories;
